import arcoAjuda from "./arco-ajuda.webp";
import arcoAmeaca from "./arco-ameaca.webp";
import { CARDS_COMUNS_SUDESTE, CARDS_RAROS_SUDESTE } from "./cartas";
import fundoColecao from "./colecao.webp";
import mascoteCabeca from "./mascote-cabeca.webp";
import mascoteCorpo from "./mascote-corpo.webp";
import fundoSelecao from "./selecao.webp";
import fundoDesfocado from "./tabuleiro-desfocado.webp";
import fundoTabuleiro from "./tabuleiro.webp";

// Região SUDESTE, bioma Mata Atlântica, mascote Mico-leão-dourado.
//
// O id é `sudeste`, e não `mata-atlantica`: a região geográfica É a região do bioma,
// e há um nome só.
//
// É a região do aluno que provavelmente MORA no bioma do mascote — a Mata Atlântica
// é o bioma das cidades onde vive a maior parte dos brasileiros —, e é o único
// mascote do acervo que pode dizer "eu quase desapareci e estou voltando" como fato:
// o mico chegou a algumas centenas de indivíduos e voltou a milhares.

export const MASCOTE_SUDESTE = {
  // O nome da espécie, como no Centro-Oeste e no Sul, e pela mesma razão: é assim
  // que os 22 textos aprovados o chamam. O apelido afetivo segue pendente do
  // cliente nas três regiões novas.
  nome: "Mico-leão-dourado",
  corpo: mascoteCorpo,
  cabeca: mascoteCabeca,
  // MASCULINO.
  //
  // A abertura já entrega a ameaça central da região — a mata partida em pedaços —
  // porque é dela que o arco dos dois cards raros depende, e porque "quase
  // desapareci" é o gancho mais forte que qualquer mascote deste acervo tem.
  fala: "Oi, explorador(a)! Sou o Mico-leão-dourado, e a minha mata virou pedaços tão pequenos que quase desapareci. Encara os desafios comigo e descubra como trazer a floresta de volta. Bora?",
  // As duas do ENCERRAMENTO. NÃO CONTAM AS CARTAS — numa trilha de 2 passos o aluno
  // termina com uma só. Quem conta é o cromo, acima do álbum.
  //
  // Esta é a única das cinco que fecha com um RESULTADO em vez de uma promessa, e
  // isso é do bioma: os outros mascotes dizem "agora tenho gente do meu lado", e
  // este pode dizer "já deu certo uma vez". É o argumento mais forte da região e não
  // aparece em nenhum dos 20 comuns.
  falaEncerramento:
    "Olha o que você descobriu na minha mata. Eu quase sumi do mapa, e é por gente como você que ainda estou aqui.",
  // O galho de álbum vazio. Não menciona carta, porque a tela não mostra nenhuma.
  falaEncerramentoSemCartas:
    "Você atravessou a minha mata inteira. Estou orgulhoso, e ainda tenho muita copa de árvore pra te mostrar."
};

export const TABULEIRO_SUDESTE = {
  fundo: fundoTabuleiro,
  // Os dois derivados saem da PRÓPRIA arte do tabuleiro — esta região recebeu UMA
  // arte, contra duas do Centro-Oeste e do Sul e três das duas primeiras. Foi o que
  // levou o pipeline a ganhar o pré-desfoque: sem ele a seleção pesava 421 KB, cinco
  // vezes o das outras regiões, porque a mata tem folha desenhada em cada pixel e
  // nenhuma das paisagens lisas que as outras usaram.
  fundoDesfocado,
  fundoSelecao,
  fundoColecao,
  // 2,0779 desde 20/08/2026: o tile encurtou quando as duas pontas da arte passaram a
  // ser escolhidas (`cortar_inicio: 40` / `cortar_fim: 190` no catálogo do pipeline).
  // 2301x1040 -> 2161x1040. É o número que o `background-size: auto 100%` usa para
  // saber onde o cenário se repete.
  proporcao: 2.0779,
  // Medido pelo método do CAMINHO, e REMEDIDO em 20/08/2026 com a costura nova. As
  // 192 posições conferidas caem sobre o chão, sem calibragem — e a curva ATRAVESSA A
  // PONTE pelo meio, que é o que se queria ver: o riacho é classificado à parte
  // (`agua`, não pisável) e a ponte é madeira com matiz de terra, então o traçado a
  // reconhece como a passagem que ela é. Aparar as pontas não alcança a ponte, que
  // fica no meio da arte — foi o primeiro risco conferido antes de mexer.
  //
  // 48,1% a 63,7%; salto na emenda 0,7pp; pior par de vizinhas 2,9pp.
  perfilDaEstrada: [
    56.6, 55.5, 54.0, 52.8, 52.2, 52.3, 53.2, 54.9, 57.1, 59.2, 61.2, 62.7,
    63.7, 63.1, 62.1, 60.4, 58.0, 55.1, 52.8, 50.8, 49.2, 48.3, 48.1, 48.5,
    48.9, 49.5, 50.1, 50.7, 51.4, 52.5, 53.9, 55.6, 57.3, 58.7, 59.7, 59.9,
    59.4, 58.2, 56.6, 54.7, 53.1, 52.1, 52.0, 52.9, 54.4, 55.9, 57.1, 57.3
  ]
};

export const CORES_SUDESTE = {
  // O accent é o LARANJA-FOGO DO MICO (#e4540c na arte, matiz 20°), e aqui a regra
  // do Norte se aplica direto: mascote quente sobre cena verde, a cor dele contrasta
  // com o cenário por construção. É o oposto do Centro-Oeste, onde o lobo ruivo
  // sobre Cerrado laranja obrigou a buscar a cor fora do mascote.
  //
  // Não se confunde com o ouro da onça (38°) apesar de os dois serem quentes: 15° de
  // matiz, e o do mico é vermelho onde o da onça é amarelo. E o `region` NÃO vai
  // para o cartão do professor de qualquer forma — `regioesDisponiveis` manda o
  // cromo e o degradê, não o accent.
  region: "#ef6c1a",
  regionStrong: "#a13d06",
  // O degradê é VERDE-ESMERALDA FRIO, e é aqui que mora o cuidado desta região: ela
  // e o Norte são as duas regiões de MATA, e é o `fundo*` que o professor compara no
  // cartão antes de ler o nome. Medido, o meio do degradê dá 146° de matiz aqui
  // contra 81° do Norte — 65° de separação, mais do que os 34° que já bastaram para
  // separar o Sul do Norte.
  //
  // A escolha também é do bioma: a Mata Atlântica é úmida e fechada, verde-esmeralda,
  // enquanto a arte da Amazônia deste acervo puxa para o oliva. A base fica em 24,5%
  // de claridade, na régua de 25% das quatro regiões já publicadas.
  fundoTopo: "#ddf0e6",
  fundoMeio: "#6fae8a",
  fundoBase: "#245945",
  // O véu sobre a ilustração embaçada do `::before`.
  veuTopo: "rgba(221, 240, 230, 0.5)",
  veuMeio: "rgba(111, 174, 138, 0.3)",
  veuBase: "rgba(36, 89, 69, 0.42)",
  // O véu radial da escolha do explorador, na paleta desta região.
  veuSelecaoCentro: "rgba(221, 240, 230, 0.4)",
  veuSelecaoMeio: "rgba(111, 174, 138, 0.2)",
  veuSelecaoBorda: "rgba(36, 89, 69, 0.1)",
  // O cromo acompanha o accent, e aqui isso exige uma justificativa que o Norte não
  // deu de graça: lá o ouro precisou ser trocado por verde porque sobre a pílula
  // BRANCA ele lia como o dourado de PRÊMIO das estrelas dos nós. O laranja-fogo do
  // mico não tem esse problema — é vermelho o bastante para ler como cor de região e
  // não como estrela —, e trocá-lo por verde traria de volta justamente a cor do
  // Norte, na região que mais precisa se distinguir dele.
  //
  // Sobre branco dá 4,1:1 na borda e 7,6:1 no texto.
  chromeBorda: "#d1580f",
  chromeTexto: "#8f3a06",
  chromeFundo: "#fdece0"
};

// A FIGURA DO ARCO, na ordem de `cardsRaros` — ameaça primeiro, fecho por último.
//
// É a cena que o aluno vê no fim de leva quando a carta rara NÃO é sorteada (ver
// `cenaDaFase` em ../../../nucleo/recompensaDaFase.js): o mascote cabisbaixo na
// ameaça, de braços erguidos na ajuda, e nenhum prêmio.
//
// SÓ A ARTE, e é o ponto. Nome e fala do arco não estão aqui porque já existem: são
// os da carta que teria caído ali. Uma segunda cópia do texto no descritor
// divergiria da primeira no dia em que alguém ajustasse uma pílula em
// `TemasDaTrilhas/`, que é a fonte de verdade e de onde `gerar-cartas-trilha.py`
// gera `cartas.js`.
//
// LISTA E NÃO `{ ameaca, ajuda }`: quem casa fase rara com momento do arco é o
// alinhamento pelo fim, que trabalha com ÍNDICE. Com um objeto de dois nomes, o
// núcleo teria de saber que o índice 0 se chama "ameaca" — ou seja conheceria a
// narrativa da região, que é exatamente o que ele não faz.
//
// Derivada por `ferramentas-da-trilha/gerar-figuras-trilha.py` (modo `arco`) da arte
// da carta rara: fora a moldura de madeira, e a borda dissolvida.
export const ARCO_SUDESTE = [arcoAmeaca, arcoAjuda];

export const REGIAO_SUDESTE = {
  id: "sudeste",
  nome: "Sudeste",
  bioma: "Mata Atlântica",
  mascote: MASCOTE_SUDESTE,
  cardsComuns: CARDS_COMUNS_SUDESTE,
  cardsRaros: CARDS_RAROS_SUDESTE,
  arco: ARCO_SUDESTE,
  tabuleiro: TABULEIRO_SUDESTE,
  cores: CORES_SUDESTE
};

export {
  CARDS_COMUNS_SUDESTE,
  CARDS_RAROS_SUDESTE,
  CARDS_SUDESTE
} from "./cartas";
